// 定义网站所有文本的翻译
export type Translations = {
  [key: string]: {
    en: string;
    zh: string;
  };
};

export const translations: Translations = {
  // 通用部分
  siteTitle: {
    en: "HackTitan",
    zh: "HackTitan"
  },
  siteDescription: {
    en: "A curated collection of tools and resources for developers and designers",
    zh: "为开发者和设计师精心整理的工具和资源集合"
  },
  
  // 搜索
  searchPlaceholder: {
    en: "Search resources...",
    zh: "搜索资源..."
  },
  searchResults: {
    en: "Search Results",
    zh: "搜索结果"
  },
  noResultsFound: {
    en: "No resources found. Try a different search term.",
    zh: "未找到相关资源，请尝试其他搜索词。"
  },
  
  // 类别名称 (与resources.ts中的ID对应)
  "my-web": {
    en: "MY WEB",
    zh: "我的网站"
  },
  "ai-websites": {
    en: "AI Websites",
    zh: "AI 网站"
  },
  "web-data": {
    en: "Web Data",
    zh: "网络数据"
  },
  "stone-turning": {
    en: "Stone Turning",
    zh: "翻石头"
  },
  "idea-validation": {
    en: "Idea Validation", 
    zh: "创意验证"
  },
  "domains": {
    en: "Domains",
    zh: "域名"
  },
  "deployment": {
    en: "Deployment",
    zh: "部署"
  },
  "growth-seo": {
    en: "SEO",
    zh: "搜索引擎优化"
  },
  "development-tools": {
    en: "Development Tools",
    zh: "开发工具"
  },
  "design-resources": {
    en: "Design Resources",
    zh: "设计资源"
  },
  
  // 资源描述 (资源ID前缀desc-以区分)
  "desc-kaggle-prompt-engineering": {
    en: "Google AI Prompt Engineering Whitepaper",
    zh: "谷歌AI提示词白皮书"
  },
  "desc-gamelistbest": {
    en: "Collection of popular and new HTML games from mainstream platforms",
    zh: "汇集多个主流HTML游戏平台的热门和新游"
  },
  "desc-claude": {
    en: "Advanced AI assistant by Anthropic",
    zh: "Anthropic开发的高级AI助手"
  },
  "desc-chatgpt": {
    en: "AI chatbot by OpenAI",
    zh: "OpenAI开发的AI聊天机器人"
  },
  "desc-deepseek": {
    en: "AI research and applications",
    zh: "AI研究与应用"
  },
  "desc-google-analytics": {
    en: "Web analytics platform by Google",
    zh: "Google提供的网站分析平台"
  },
  "desc-google-search-console": {
    en: "SEO and site performance monitoring",
    zh: "SEO和网站性能监控工具"
  },
  "desc-similarweb": {
    en: "Website traffic statistics and analytics",
    zh: "网站流量统计和分析工具"
  },
  "desc-toolify": {
    en: "Discovery platform for digital tools",
    zh: "数字工具发现平台"
  },
  "desc-bolt-new": {
    en: "Rapid idea validation platform",
    zh: "快速创意验证平台"
  },
  "desc-instant-domain-search": {
    en: "Real-time domain availability checker",
    zh: "实时域名可用性检查器"
  },
  "desc-spaceship": {
    en: "Modern domain management platform",
    zh: "现代域名管理平台"
  },
  "desc-vercel": {
    en: "Platform for frontend frameworks and static sites",
    zh: "前端框架和静态站点托管平台"
  },
  "desc-cloudflare": {
    en: "Web performance & security company",
    zh: "网络性能和安全服务提供商"
  },
  "desc-ahrefs": {
    en: "SEO tools & resources to grow your search traffic",
    zh: "SEO工具和资源，提升搜索流量"
  },
  "desc-semrush": {
    en: "All-in-one digital marketing toolkit",
    zh: "一站式数字营销工具包"
  },
  "desc-github": {
    en: "Platform for version control and collaboration",
    zh: "代码版本控制和协作平台"
  },
  "desc-nodejs": {
    en: "JavaScript runtime built on Chrome's V8 JavaScript engine",
    zh: "基于Chrome V8引擎的JavaScript运行时"
  },
  "desc-perplexity": {
    en: "AI-powered search and discovery engine",
    zh: "AI驱动的搜索和发现引擎"
  },
  "desc-reactjs": {
    en: "A JavaScript library for building user interfaces",
    zh: "用于构建用户界面的JavaScript库"
  },
  "desc-vscode": {
    en: "Lightweight and powerful code editor",
    zh: "轻量且功能强大的代码编辑器"
  },
  "desc-dribbble": {
    en: "Design portfolio and inspiration platform",
    zh: "设计作品集和灵感平台"
  },
  "desc-figma": {
    en: "Collaborative interface design tool",
    zh: "协作式界面设计工具"
  },
  "desc-behance": {
    en: "Creative work showcase platform by Adobe",
    zh: "Adobe旗下的创意作品展示平台"
  },
  
  // 友情链接
  friendlyLinks: {
    en: "Friendly Links",
    zh: "友情链接"
  },
  asphaltCalculator: {
    en: "Asphalt Calculator",
    zh: "沥青计算器"
  },
  
  // 版权信息
  copyright: {
    en: "© 2025 HackTitan design by Paxon",
    zh: "© 2025 HackTitan 由 Paxon 设计"
  }
};

// 辅助函数：根据当前语言和key获取翻译文本
export function getTranslation(key: string, language: string = 'en'): string {
  // 如果找不到key，返回key本身
  if (!translations[key]) {
    return key;
  }
  
  // 如果该key没有当前语言的翻译，回退到英文
  return translations[key][language as 'en' | 'zh'] || translations[key]['en'];
} 